<template>
  <div>
    <template>
      <template v-if="isPwChk=='N'">
        <div :id="board.boardTypeCd == 'CMS002.img' || board.boardTypeCd == 'CMS002.imgThum'?'imageBoard':'dynamicBoard'" style="width:100%; margin-top: 20px;">
          <div class="pwd_check">
            {{$t('message.L000004')}}<br><br>
            <ul>
              <li>
                <label for="c_pwd" class="text">{{$t('pw')}} :</label> 
                <input id="c_pwd" type="password" size="15" :title="$t('pwInput')" v-model="searchParam.inputPw" @keydown="doPwEnter" class="board_input" style="vertical-align:middle;" autocomplete="off">
                <img src="" width="34" height="20" :alt="$t('confirm')" style="vertical-align:middle;padding-left:3px;" @click="doChkPw" />
              </li>
            </ul>
          </div>
          <div class="pwd_check_button">
            <span>
              <a href="javascript:void(0);" @click="goBack" class="cbtn cbtn_g" >{{$t('back')}}</a>
            </span>
          </div>
        </div>
      </template>
      <template v-if="isPwChk=='Y'">
        <!-- 쓰기 -->
        <div id="dynamicBoard" style="width:100%;">
          <div class="guide">
            <span>
              <img src="" :alt="$t('requList')">{{$t('message.requCheck')}}
            </span>
          </div>
          <div class="table_bwrite" >
            <boardTable ref="tableBwrite" :summary="`${$t(title)}`+`${$t('of')}`+ `${summary}`+`${$t('ckIt')}`" :fields="fieldList" :isModify="true" :title="board.boardNm">
              <template #colgroup></template>
              <template #body>
                <!-- 그룹사용여부 -->
                <tr v-if="board.grpYn=='Y'">
                  <th scope="row" colspan="2">
                    {{$t('categori')}}
                  </th>
                  <td>
                    <select id="categori" v-model="detailMain.grpCd" class="modifySelect" :title="$t('categori')">
                      <template v-for="(item, index) in boardGrpCdList">
                        <option v-if="doSelect(item,index,'grpCd')" selected :value="item.grpCd" :key="`sel_${index}`" :title="item.grpNm">{{item.grpNm}}</option>
                        <option v-else :value="item.grpCd" :key="`nosel_${index}`" :title="item.grpNm">{{item.grpNm}}</option>
                      </template>
                    </select>
                  </td>
                </tr>
                <!-- 비공개여부 -->
                <tr v-if="board.ndisYn == 'Y' && board.ndisRequYn == 'N'">
                  <th scope="row" colspan="2">
                    <img :alt="$t('requList')" src=""> {{$t('openYn')}}
                  </th>
                  <td>
                    <input type="radio" id="radioOpen" v-model="detailMain.ndisYn" value="N" :title="$t('open')">
                    <label for="radioOpen">{{$t('open')}}</label>
                    <input type="radio" id="radioNdis" v-model="detailMain.ndisYn" value="Y" class="ml5" :title="$t('ndisYn')">
                    <label for="radioNdis">{{$t('ndisYn')}}</label>
                  </td>
                </tr>
                <!-- 공지여부 -->
                <template v-if="board.noticeYn == 'Y'">
                  <!-- 공지사용 유무 -->
                  <tr>
                    <th scope="row" colspan="2">
                      <img :alt="$t('requList')" src=""> {{$t('homepageNoticeYn')}}
                    </th>
                    <td>
                      <input id="radioNtY" type="radio" v-model="detailMain.noticeYn" value="Y" :title="$t('use')">
                      <label for="radioNtY">{{$t('use')}}</label>
                      <input id="radioNtN" type="radio" v-model="detailMain.noticeYn" value="N" class="ml5" :title="$t('noUse')">
                      <label for="radioNtN">{{$t('noUse')}}</label>
                    </td>
                  </tr>
                  <!-- 공지 기간 및 무제한 사용 유무 -->
                  <tr v-if="detailMain.noticeYn == 'Y'">
                    <th scope="row" colspan="2">
                      <img :alt="$t('requList')" src=""> {{$t('noticeTerm')}}
                    </th>
                    <td>
                      <input type="date" v-model="detailMain.noticeDispStDt" :title="$t('noticeDispStDt')">
                      <input type="time" style="margin-left: 4px;" v-model="detailMain.noticeDispStTm" title="공지사항표시시작시간"> ~ 
                      <input type="date" v-model="detailMain.noticeDispEnDt" :title="$t('noticeDispEnDt')">
                      <input type="time" style="margin-left: 4px;" v-model="detailMain.noticeDispEnTm" title="공지사항표시종료시간">
                      <input type="checkbox" class="ml10" v-model="detailMain.noticeTermLimitYn" true-value="Y" false-value="N" :title="$t('noticeTermLimitYn')">
                      <label :for="detailMain.noticeTermLimitYn" class="pl3">{{$t('noticeTermNoLimit')}}</label>
                    </td>
                  </tr>
                </template>
                <!-- 메인표시여부 -->
                <template v-if="board.mainDispYn == 'Y'">
                  <!-- 메인표시 사용 유무 -->
                  <tr>
                    <th scope="row" colspan="2">
                      <img :alt="$t('requList')" src=""> {{$t('homepageMainDispYn')}}
                    </th>
                    <td>
                      <input type="radio" v-model="detailMain.mainYn" value="Y" :title="$t('use')">
                      <label for="Y">{{$t('use')}}</label>
                      <input type="radio" v-model="detailMain.mainYn" value="N" class="ml5" :title="$t('noUse')">
                      <label for="N">{{$t('noUse')}}</label>
                    </td>
                  </tr>
                  <!-- 메인표시 기간 및 무제한 사용여부 -->
                  <tr v-if="detailMain.mainYn == 'Y'">
                    <th scope="row" colspan="2">
                      <img :alt="$t('requList')" src=""> {{$t('mainDispTerm')}}
                    </th>
                    <td>
                      <input type="date" v-model="detailMain.mainDispStDt" :title="$t('mainDispStDt')">
                      <input type="time" style="margin-left: 4px;" v-model="detailMain.mainDispStTm" title="메인표시시작시간"> ~ 
                      <input type="date" v-model="detailMain.mainDispEnDt" :title="$t('mainDispEnDt')">
                      <input type="time" style="margin-left: 4px;" v-model="detailMain.mainDispEnTm" title="메인표시종료시간">
                      <input type="checkbox" class="ml10" v-model="detailMain.mainTermLimitYn" true-value="Y" false-value="N" :title="$t('mainTermNoLimit')">
                      <label :for="detailMain.mainTermLimitYn" class="pl3">{{$t('mainTermNoLimit')}}</label>
                    </td>
                  </tr>
                </template>
                <!-- 게시기간(달력형 게시판일때는 무조건 입력) -->
                <tr v-if="board.postTeamYn=='Y' || board.boardTypeCd == 'CMS002.cal'">
                  <th scope="row" colspan="2">
                    <img :alt="$t('requList')" src="">{{$t('postDd')}}
                  </th>
                  <td>
                    <input type="date" v-model="detailMain.postStDt" format="yyyymmdd" :title="$t('postStDt')">
                    <input type="time" style="margin-left: 4px;" v-model="detailMain.postStTm" :title="게시시작시간"> ~ 
                    <input type="date" v-model="detailMain.postEnDt" format="yyyymmdd" :title="$t('postEnDt')">
                    <input type="time" style="margin-left: 4px;" v-model="detailMain.postEnTm" :title="게시종료시간">
                  </td>
                </tr>
                <!-- 비밀번호사용여부 -->
                <tr v-if="!isModify">
                  <th scope="row" colspan="2">
                    <label>
                      <img :alt="$t('requList')" src=""> {{$t('pw')}}
                    </label>
                  </th>
                  <td>
                    <input type="password" size="22" class="board_input" v-model="detailMain.pw" maxlength="256" :title="$t('password')"> 
                    <span class="text1">* {{$t('message.inputPw')}}</span>
                  </td>
                </tr>
                <!-- 공공누리 -->
                <tr v-if="board.koglYn=='Y'">
                  <th scope="row" colspan="2">
                    <label>{{$t('kogl')}}</label>
                  </th>
                  <td>
                    <select v-model="detailMain.koglCd" :title="$t('kogl')">
                      <template v-for="(item, index) in koglCdList">
                        <option v-if="doSelect(item, index, 'koglCd')" selected :value="item.cmnCd" :key="`sel_${index}`" :title="$t(item.mulLangCd)">{{$t(item.mulLangCd)}}</option>
                        <option v-else :value="item.cmnCd" :key="`nosel_${index}`" :title="$t(item.mulLangCd)">{{$t(item.mulLangCd)}}</option>
                      </template>
                    </select>
                  </td>
                </tr>
                <template v-for="(item, index) in fieldList">
                  <!-- 입력 유형이 리스트인건 따로 구현 -->
                  <tr :key="`tr_${index}`" v-if="item.fieldType != 'CMS003.l'">
                    <th v-if="item.fieldType !='CMS003.e'" scope="row" style="word-break: break-all;overflow-wrap: break-word;" colspan="2" :rowspan="setRowspan(item)">
                      <label :for="item.fieldCdNm">
                        <img v-if="item.requYn =='Y'" :alt="$t('requList')" src=""> {{item.fieldNm}}
                      </label>
                    </th>
                    <td :colspan="item.fieldType =='CMS003.e'?3:''" :class="item.fieldType =='CMS003.e'?'padding0':''">
                      <!-- 입력 -->
                      <input :title="item.fieldNm" v-if="item.fieldType=='CMS003.i'" type="text" :size="item.fieldCdNm =='field03'?100:20" class="board_input postInput" v-model="detailMain[item.fieldCdNm]" :maxlength="item.fieldCdNm =='field03'?200:item.fieldCdNm =='field02'?50:1000" :readonly="item.fieldCdNm =='field02' && board.certYn == 'Y'?true:false" v-tooltip.top-start="item.tooltip" > 
                      <!-- 라디오 -->
                      <span v-tooltip.top-start="item.tooltip" v-if="item.fieldType=='CMS003.r'">
                        <template v-for="(subItem, subIdx) in getOption(item, item.fieldType=='CMS003.r',detailMain)" >
                          <input :title="subItem.value" type="radio" :value="subItem.value" v-model="detailMain[item.fieldCdNm]" :key="`radio_${subIdx}`" >
                          <label :for="subItem.value" :key="`label_${subIdx}`" class="mr10">{{subItem.value}}</label> 
                        </template>
                      </span>
                        
                      <!-- 체크박스 -->
                      <span v-tooltip.top-start="item.tooltip" v-if="item.fieldType=='CMS003.c'">  
                        <template v-for="(subItem, subIdx) in getOption(item, item.fieldType=='CMS003.c', detailMain)">
                          <input :title="subItem.value"  type="checkbox" :value="subItem.value" v-model="detailMain[item.fieldCdNm]" :key="`checkbox_${subIdx}`" >
                          <label :for="subItem.value" :key="`label_${subIdx}`">{{subItem.value}}</label>
                        </template>
                      </span>

                      <!-- 콤보 -->
                      <span v-tooltip.top-start="item.tooltip" v-if="item.fieldType=='CMS003.s'">
                        <select :title="item.fieldNm" v-model="detailMain[item.fieldCdNm]" >
                          <option :title="subItem.text" v-for="(subItem, subIdx) in getOption(item, item.fieldType=='CMS003.s', detailMain)" :value="subItem.value" :key="`select_${subIdx}`" >{{subItem.text}}</option>
                        </select>
                      </span>
                      
                      <!-- 일 -->
                      <input :title="item.fieldNm" v-if="item.fieldType=='CMS003.d'" type="date" v-model="detailMain[item.fieldCdNm]" v-tooltip.top-start="item.tooltip" >
                      <!-- 일시 -->
                      <input :title="item.fieldNm" v-if="item.fieldType=='CMS003.dt'" type="datetime-local" v-model="detailMain[item.fieldCdNm]" v-tooltip.top-start="item.tooltip" >
                      <!-- 태그 -->
                      <textarea :title="item.fieldNm" v-if="item.fieldType=='CMS003.t'" v-model="detailMain[item.fieldCdNm]" style="width:100%; height:250px;" maxlength="4000" v-tooltip.top-start="item.tooltip" ></textarea>
                      <!-- 장문입력 -->
                      <textarea :title="item.fieldNm" v-if="item.fieldType=='CMS003.ta'" v-model="detailMain[item.fieldCdNm]" class="postInput" style="height:250px;" maxlength="4000" v-tooltip.top-start="item.tooltip" ></textarea>
                      <!-- 에디터 -->
                      <tui-editor :title="item.fieldNm" ref="toastuiEditor" v-if="item.fieldType=='CMS003.e'" v-model="detailMain[item.fieldCdNm]" class="editorTd" v-tooltip.top-start="item.tooltip" />
                      <span v-tooltip.top-start="item.tooltip" v-if="item.fieldType =='CMS003.ll'">
                        <boardLinkInput :title="item.fieldNm" v-model="detailMain" :fieldData="item" style="display: flex; align-items: center;" />
                      </span>
                      <!-- 기간 -->
                      <span v-tooltip.top-start="item.tooltip" v-if="item.fieldType =='CMS003.p'">
                        <!-- 초기값 설정 때문에 따로 컴포넌트로 분리 -->
                        <boardPeriodInput :title="item.fieldNm" v-model="detailMain" :fieldData="item" />
                      </span>
                      <!-- 주소 -->
                      <span v-tooltip.top-start="item.tooltip" v-if="item.fieldType =='CMS003.a'">
                        <boardAddrInput :title="item.fieldNm" v-model="detailMain" :fieldData="item" />
                      </span>
                    </td>
                  </tr>
                  <!-- 리스트 -->
                  <template v-else>
                    <tr v-for="(listItem, listIndex) in item.fieldData.split(',')" :key="listIndex">
                      <th :rowspan="item.fieldData.split(',').length" v-if="listIndex==0">
                        <label :for="item.fieldCdNm">
                          <img v-if="item.requYn =='Y'" :alt="$t('requList')" src=""> {{item.fieldNm}}
                        </label>
                      </th>
                      <th scope="row" class="thlist">
                        <label for="b_temp9">
                          <img v-if="item.requYn =='Y'" :alt="$t('requList')" src=""> {{ listItem }}
                        </label>
                      </th>
                      <td>
                        <span v-tooltip.top-start="item.tooltip">
                          <!-- 초기값 설정 때문에 따로 컴포넌트로 분리 -->
                          <boardListInput :title="item.fieldNm" v-if="item.fieldType =='CMS003.l'" v-model="detailMain" :fieldData="item" :listIndex="listIndex" />
                        </span>
                      </td>
                    </tr>
                  </template>
                </template>
                <!-- 첨부파일 -->
                <tr v-if="board.attcYn == 'Y'">
                  <th scope="row" colspan="2">
                    <label>{{$t('attcFile')}}</label>
                  </th>
                  <td>
                    <fileUpload ref="fileUploadComp" :attcNo="detailMain.attcNo" :fileInfo="fileInfo" />
                  </td>
                </tr>
                <!-- 이미지 첨부파일 -->
                <tr v-if="board.boardTypeCd == 'CMS002.img' || board.boardTypeCd == 'CMS002.imgThum' || board.boardTypeCd == 'CMS002.lis' || board.boardTypeCd == 'CMS002.lisv' || board.boardTypeCd == 'CMS002.exh' || board.boardTypeCd == 'CMS002.exhn'">
                  <th scope="row" colspan="2">
                    <label>{{$t('img')}}</label>
                  </th>
                  <td>
                    <imageUpload ref="imageUploadComp" :boardNo="detailMain.boardNo" :postNo="detailMain.postNo" :fileInfo="imageInfo" />
                  </td>
                </tr>
              </template>
            </boardTable>
          </div>

          <!-- 버튼 -->
          <div class="board_button2">
            <span>
              <button id="submitbtn" class="cbtn cbtn_point" @click="doSave" @keydown="doKeydownSave($event)" >{{$t('save')}}</button>
            </span>
            <span>
              <a href="javascript:void(0);" class="cbtn cbtn_g" @click="doList" title="화면이동">{{$t('homepageList')}}</a>
            </span>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import boardTable from '@/views/board/boardTable'
import tuiEditor from '@/views/component/TuiEditor';
import fileUpload from '@/views/component/fileUpload'
import imageUpload from '@/views/component/ImageUpload'
import boardListInput from '@/views/component/BoardListInput'
import boardLinkInput from '@/views/component/BoardLinkInput'
import boardPeriodInput from '@/views/component/BoardPeriodInput'
import boardAddrInput from '@/views/component/BoardAddrInput'

import {sendPostImg} from '@/libs/comm/transection';
import { nullCheck } from '@/libs/comm/util';
import {isJson} from "@/libs/comm/util";
import HDate from '@/libs/date';

export default {
  components: {
    boardTable,
    fileUpload,
    imageUpload,
    'tui-editor': tuiEditor,
    boardListInput,
    boardLinkInput,
    boardPeriodInput,
    boardAddrInput,
  },
  props: {
    board: {
      type: Object,
      default: () => new Object()
    },
    depth: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters([
      'certData',
      'subMenuTitle',
    ]),
  },
  watch: {
    certData(newVal) {
      if(newVal != null && newVal != ''){
        const param = JSON.parse(newVal)
        this.doResult(param)
      }
    },
    saveData(newVal) {
      if(newVal != null && newVal != '') {
        this.saveData = newVal
      }
    }
  },
  data() {
    return {
      condCode: [
        {cd: 'CMS015', useYn: 'Y', listNm: 'koglCdList'},
      ],
      koglCdList: [],
      reqNum: '',
      saveData: {
        id: '',
        nm: '',
        requApprYn: 'N',
        selApprYn: 'N',
      },
      searchParam: {
        writeYn: 'Y',
        contentNo : '',
        postNo: '',
        inputPw: null,
        orginPostNo: '',
        modifyYn: 'Y',
      },
      isPwChk: null,
      fieldList: [],
      boardGrpCdList: [],
      commList: [],
      detailMain: {
        contentNo: null,
        postNo: null,
        termsNo: 0,
        unLimitedYn: 'N',
        nextCloseYn: 'N' ,
        popupTypeCd: null,
        accCd: null,
        dispStDt:null,
        dispEnDt:null,
        useYn: null,
        nextCloseDd:null,
        widthPixel: null,
        heightPixel: null,
        topPixel:'0',
        leftPixel:'0',
        content:'<p></p>',
        noticeYn:'N',
        mainYn: 'N',
        ndisYn: 'N',
        grpCd: null,
        id: null,
        pw: null,
        field01: null,
        field02: null,
        field03: null,
        field04: null,
        field05: null,
        field06: null,
        field07: null,
        field08: null,
        field09: null,
        field10: null,
        field11: null,
        field12: null,
        field13: null,
        field14: null,
        field15: null,
        field16: null,
        field17: null,
        field18: null,
        field19: null,
        field20: null,
        field21: null,
        field22: null,
        field23: null,
        field24: null,
        postStDt: null,
        postEnDt: null,
        postStTm: null,
        postEnTm: null,
        mainDispStDt: null,
        mainDispEnDt: null,
        mainDispStTm: null,
        mainDispEnTm: null,
        mainTermLimitYn: 'N',
        noticeDispStDt: null,
        noticeDispEnDt: null,
        noticeDispStTm: null,
        noticeDispEnTm: null,
        noticeTermLimitYn: 'N',
        orginPostNo: null,
        requApprYn: 'N',
        selApprYn: 'N',
        attcNo: null,
        koglCd: '',
      },
      fileInfo: {
        fileComplet: null,
        fileSize: '5242880', 
        fileExt: ['hwp', 'doc', 'ppt', 'xls', 'txt', 'gif', 'jpg', 'docx', 'pptx', 'xlsx', 'zip', 'alz', 'rar', 'pdf'],
        fileCnt: 2,
        multiple: false,
        fileDownloadNm: this.$t('attcFile'),
      },
      imageInfo: {
        fileComplet: false,
        fileSize: '5242880',
        fileExt: ['jpg', 'jpeg', 'png', 'bmp', 'svg', 'gif'],
        fileCnt: 2,
        multiple: false,
        fileDownloadNm: this.$t('attcFile'),
      },
      saveParam: {
        data: {}
      },
      isModify: false,
      summary: '',
      title: '',
      ctntFieldType: '',
      certId: null,
    }
  },
  mounted() {
    const defalutCode = {
      cdNm: this.$t('select'),
      cmnCd: null,
      dtlCd: null,
      mulLangCd: 'select',
    }

    this.$codeLists(this, this.condCode).then(() => {
      this.koglCdList = [defalutCode,...this.koglCdList];
    })

    this.searchParam.contentNo = this.board.boardNo;
    this.detailMain.contentNo = this.board.boardNo;
    this.searchParam.postNo = this.$route.query.postNo;
    this.searchParam.orginPostNo = this.$route.query.orginPostNo;
    this.title = this.subMenuTitle;

    if(this.searchParam.orginPostNo != null && this.searchParam.orginPostNo != ''){
      this.searchParam.postNo = this.$route.query.orginPostNo;
    }

    if(this.searchParam.postNo != null && this.searchParam.postNo != '') {
      this.isModify=true;

      if(this.board.pwYn == 'Y') {
        this.isPwChk='N';
      }
      
      if(this.board.certYn != 'Y') {
        this.doDetail();
      }
    }else{
      this.doBoardInfo();
    }
  },
  methods: {
    goBack() {
      let name = 'content'
      const query = {...this.$route.query}
      delete query.postNo
      
      if(this.routeDiv == 'direct') {
        name = 'directBoard'
      }

      this.$router.push({name: name, query: query})
    },
    doChkPw() {
      const inputPw = this.searchParam.inputPw;

      if(inputPw == null || inputPw == '') {
        this.$swal.fire(this.$t('error'), this.$t('message.L000004') , 'error')
        return;
      }
      this.doDetail();
    },
    doPwEnter(event) {
      if(event.keyCode == 13) {
        this.doChkPw();
      }
    },
    doBoardInfo(){
      let summaryData = ''
      this.$tran('/site/external/contents/selectBoardInfo', this.searchParam).then(response => {
        this.fieldList = response.data.fieldList;
        this.boardGrpCdList = response.data.grpList;
        
        this.isPwChk='Y';

        this.$nextTick(() => {
          const ctntData = this.fieldList.find((e) => e.fieldCdNm == 'field08');
          
          if(ctntData != null) {
            this.ctntFieldType = ctntData.fieldType;
          }
          
          const boardNm = this.$t(this.subMenuTitle);
          const metaInfoData = {
            title: `${this.$t('차세대정보보안인증원')}: ${boardNm}-${this.$t('write')}`
          }
          this.$store.dispatch('setMetaInfo', metaInfoData);

          if(ctntData != null) { 
            if(this.ctntFieldType == 'CMS003.e') {
              this.detailMain.field08 = this.board.defContent;
            }
          }

          if(this.board.postTeamYn=='Y') {
            const hdate = new HDate();
            const today = hdate.getMaskFormatString(new Date(),'yyyy-MM-dd');
            const postStTm = hdate.getMaskFormatString(new Date(),'H:mm');
            let postStDt = hdate.getMaskFormatString(new Date(),'yyyyMMdd');
            const postEnDt = hdate.addDate(postStDt, this.board.postDd,'yyyy-MM-dd');

            this.detailMain.postStDt = today;
            this.detailMain.postStTm = postStTm;
            this.detailMain.postEnDt = postEnDt;
            this.detailMain.postEnTm = postStTm;
          }

          if(this.board.pwYn == 'Y' || this.board.ndisYn == 'Y'	) {
            summaryData += ', ' + this.$t('pw')
          }
          this.summary = summaryData

          if(this.board.attcYn == 'Y') {
            this.fileInfo = {
              fileComplet: null,
              fileSize: this.board.attcLimitSize * 1048576, 
              fileExt: this.board.attcAllowExts,
              fileCnt: this.board.attcLimitNo,
              multiple: true,
              fileDownloadNm: this.$t('attcFile'),
            }
          }          
        })
      })
    },
    doDetail() {
      let summaryData = ''
      this.$tran('/site/external/contents/selectPostModDetail', this.searchParam).then(response => {
        if(response.data == null || response.data == ''){
          if(this.board.certYn == 'Y') {
            this.detailMain.id=this.certId;
          }
          return false;
        }

        this.fieldList = response.data.fieldList;
        this.boardGrpCdList = response.data.grpList;
        const postNo = this.searchParam.postNo;
        
        this.isPwChk = 'Y';

        this.$nextTick(() => {
          const ctntData = this.fieldList.find((e) => e.fieldCdNm == 'field08');
          
          if(ctntData != null) {
            this.ctntFieldType = ctntData.fieldType;
          }

          const metaInfoData = {
            title: `${this.$t('차세대정보보안인증원')}: ${this.board.boardNm}-${this.$t('write')}`
          }
          this.$store.dispatch('setMetaInfo', metaInfoData);

          if(postNo!= null && postNo != '') {
            this.isModify = true;
            this.detailMain = response.data.post;

            if(this.board.certYn == 'Y') {
              this.detailMain.id=this.certId;
            }
            if(this.searchParam.orginPostNo != null && this.searchParam.orginPostNo != '') {
              this.isModify = false;
              this.detailMain.orginPostNo=this.searchParam.orginPostNo
              this.detailMain.acctCnt=0
              this.detailMain.attcNo=''
              this.detailMain.boardDepth=this.detailMain.boardDepth+1;
              this.detailMain.crud='N';
              this.detailMain.field03=`RE: ${this.detailMain.field03}`;
              this.detailMain.field08=`<p></p><p>-------------------------------------------------- ${this.$t('orginPostCtnt')} -----------------------------------------------------------</p>${this.detailMain.field08}`;
              this.detailMain.field17='';
              this.detailMain.ip=null;
              this.detailMain.field01=null;
              this.detailMain.field04=null;
              this.detailMain.field05=null;
              this.detailMain.field06=null;
              this.detailMain.field07=null;
              this.detailMain.field09=null;
              this.detailMain.field10=null;
              this.detailMain.field11=null;
              this.detailMain.field12=null;
              this.detailMain.field13=null;
              this.detailMain.field14=null;
              this.detailMain.field15=null;
              this.detailMain.field16=null;
              this.detailMain.field18=null;
              this.detailMain.field19=null;
              this.detailMain.field20=null;
              this.detailMain.field21=null;
              this.detailMain.field22=null;
              this.detailMain.field23=null;
              
              if(this.board.certYn != 'Y') {
                this.detailMain.field02=null;
              }
            }
          }else{
            if(ctntData != null) { 
              if(this.ctntFieldType == 'CMS003.e') {
                this.detailMain.field08 = this.board.defContent;
              }
            }
          }

          for(let i=0; i < this.fieldList.length; i++){
            if(summaryData == null || summaryData == '') {
              summaryData += this.fieldList[i].fieldNm
            }else{
              summaryData += ', ' + this.fieldList[i].fieldNm
            }
          }
          if(this.board.pwYn == 'Y') {
            summaryData += ', ' + this.$t('pw')
          }
          this.summary = summaryData

          if(this.board.attcYn == 'Y') {
            this.fileInfo = {
              fileComplet: null,
              fileSize: this.board.attcLimitSize * 1048576, 
              fileExt: this.board.attcAllowExts,
              fileCnt: this.board.attcLimitNo,
              multiple: true,
              fileDownloadNm: this.$t('attcFile'),
            }
          }
        })
      })
    },
    doSelect(item, index, cdNm) {
      const depthGrpCd =  this.$route.query[`s${this.depth}`]

      if(cdNm == 'grpCd') {
        if(this.detailMain.grpCd == null || this.detailMain.grpCd == '') {
          if(depthGrpCd != null && depthGrpCd != '') {
            this.detailMain.grpCd = depthGrpCd
          }else{
            if(index == 0){
              this.detailMain.grpCd=item.grpCd
              return true
            }
          }
        }
        return false
      }else if(cdNm == 'koglCd') {
        if(this.detailMain.koglCd == null || this.detailMain.koglCd == '') {
          if(index == 0) {
            this.detailMain.koglCd = item.cmnCd;
            return true
          }
        }
      }
    },
    passCheckBoard(pwd) {
      const regPass = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,15}$/;

      if(!regPass.test(pwd)) {
        this.$swal.fire(this.$t('error'), this.$t('usePw'), 'error');
        return false;
      }
      
      // 영문, 숫자, 특수문자 혼용
      let chk = 0; 
      let eng = false;
      let num = false;
      let emo = false;
      if(pwd.search(/[0-9]/g) != -1 ){
        chk ++;
        num = true;
      }
      if(pwd.search(/[a-z]/ig)  != -1 ){
        chk ++;
        eng = true;
      }
      if(pwd.search(/[!@#$%^&*()?_~]/g)  != -1  ){
        chk ++;
        emo = true;
      }
      if(chk < 3) {
        this.$swal.fire(this.$t('error'), this.$t('usePw'), 'error');
        return false;
      }

      if(!/^[a-zA-Z0-9!@#$%^&*()?_~]{8,15}$/.test(pwd)) {
        this.$swal.fire(this.$t('error'), this.$t('usePw'), 'error');
        return false;
      }
          
          // 동일한 문자/숫자 4이상, 연속된 문자
      if(/(\w)\1\1\1/.test(pwd) || this.isContinuedValue(pwd)) {
        this.$swal.fire(this.$t('error'), this.$t('numPw'), 'error');
        return false;
      }
      return true;
    },
    isContinuedValue(value) {
      let intCnt1 = 0;
      let intCnt2 = 0;
      let temp0 = "";
      let temp1 = "";
      let temp2 = "";
      let temp3 = "";

      for (var i = 0; i < value.length-3; i++) {
        temp0 = value.charAt(i);
        temp1 = value.charAt(i + 1);
        temp2 = value.charAt(i + 2);
        temp3 = value.charAt(i + 3);

        if (temp0.charCodeAt(0) - temp1.charCodeAt(0) == 1
            && temp1.charCodeAt(0) - temp2.charCodeAt(0) == 1
            && temp2.charCodeAt(0) - temp3.charCodeAt(0) == 1) {
          intCnt1 = intCnt1 + 1;
        }

        if (temp0.charCodeAt(0) - temp1.charCodeAt(0) == -1
            && temp1.charCodeAt(0) - temp2.charCodeAt(0) == -1
            && temp2.charCodeAt(0) - temp3.charCodeAt(0) == -1) {
          intCnt2 = intCnt2 + 1;
        }
      }
      return (intCnt1 > 0 || intCnt2 > 0);
    },
    doSave() {
      let url = ''
      this.saveParam.data={...this.detailMain, crud:'N'};
      this.saveParam.data.contentNo = this.searchParam.contentNo
      
      if(!this.isModify) {
        if(nullCheck(this.detailMain.pw, this.$t('pw'))) {
          return;
        }

        if(!this.passCheckBoard(this.detailMain.pw)) {
          return;
        }
      }

      if(this.board.postTeamYn=='Y' || this.board.boardTypeCd == 'CMS002.cal') {
        if(nullCheck(this.detailMain.postStDt, this.$t('mainDispStDt'))) {
          return;
        }

        if(nullCheck(this.detailMain.postEnDt, this.$t('mainDispEnDt'))) {
          return;
        }
      }

      // 필수 값 체크
      for(let i=0; i < this.fieldList.length; i++){
        let item = this.fieldList[i]
        if(item.requYn == 'Y') {
          if(nullCheck(this.detailMain[item.fieldCdNm], item.fieldNm)) {
            return;
          }
        }
      }

      if(this.isModify) {
        this.saveParam.data.crud='U'
        url = '/site/external/contents/updatePost';
      }else{
        if(this.board.certYn == 'Y' && this.detailMain.termsNo != null && this.detailMain.termsNo != '') {
          if(this.detailMain.requApprYn != 'Y' && !this.isModify) {
            this.$swal.fire(this.$t('error'), this.$t('privacyChk'), 'error');
            return
          }
        }

        url = '/site/external/contents/insertPost';
      } 
      
      let fileList = new FormData();
      let fList = new FormData();

      const boardTypeCd = this.board.boardTypeCd;

      if(boardTypeCd == 'CMS002.img' || boardTypeCd == 'CMS002.imgThum' || boardTypeCd == 'CMS002.lis' || boardTypeCd == 'CMS002.lisv' || boardTypeCd == 'CMS002.exh' || boardTypeCd == 'CMS002.exhn') {
        fileList = this.$refs.imageUploadComp.getFile();
      }

      if(this.board.attcYn == "Y"){
        fList = this.$refs.fileUploadComp.getFile();
      }   

      for (let data of fList.entries()) {
          fileList.append(data[0], data[1]);
      }

      sendPostImg(url, this.saveParam, fileList).then(response => {
        this.$nextTick(() => {
          this.doList()
        })
      }).catch(e=> {
        if(this.board.pwYn == 'Y') {
          this.isPwChk='N';
        }
      })
    },
    doList() {
      let name = 'content'
      const query = {...this.$route.query}
      delete query.boardNo
      delete query.postNo
      delete query.orginPostNo;
      
      if(this.board.ndisYn == 'Y') {
        // 비공개 사용할 경우 현재 뎁스의 그룹정보 삭제
        delete query[`s${this.depth}`]
      }

      if(this.$route.name.indexOf('direct') == 0) {
        name = 'directBoard'
      }
      
      this.$router.push({name: name, query: query});
    },
    getOption(item, isExec=false, obj){
      const result = [];
      if(isJson(item.fieldData)){
        const fieldData = item.fieldData;
        const result = JSON.parse(fieldData)

        result.forEach((e)=>{
          if(!e.hasOwnProperty('value')){
            e.value = e.text
          }
        })
        return result
      }else{
        if(isExec){
          if(item.fieldType=='CMS003.c' && this.detailMain[item.fieldCdNm] == null){
            this.detailMain[item.fieldCdNm]=[]
          }
          const vsOptions = item.fieldData
          
          if(vsOptions != null && vsOptions != ''){
            const vaOptions = vsOptions.split(',')
            const result = []
            for(const val in vaOptions){
              let data = vaOptions[val];
              if(data.indexOf('$D$') > -1){
                if(obj[item.fieldCdNm] == null || obj[item.fieldCdNm] == ''){
                  obj[item.fieldCdNm] = data.replace('$D$','')
                }
              }
              const option = {
                text: data.replace('$D$',''),
                value: data.replace('$D$',''),
              }
              result.push(option)
            }
            return result
          }
        }
      }
      return result
    },
    setRowspan(item) {
      const fieldType = item.fieldType;

      // 필드 유형 : 리스트
      if(fieldType == 'CMS003.l') {
        const fieldDatas = item.fieldData.split(',');
        
        // 테이블 열 병합
        if(fieldDatas.length > 0) {
          return fieldDatas.length;
        }
      }
    },
    doKeydownSave(event) {
      if(event.keyCode == 13) {
        this.doSave();
      }
    },
  },
}
</script>